module.exports = __webpack_public_path__ + "static/media/paymet-icons.8b1cd21f.svg";